import { render, staticRenderFns } from "./CourseLicences.vue?vue&type=template&id=f16fae82&"
import script from "./CourseLicences.vue?vue&type=script&lang=js&"
export * from "./CourseLicences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports